export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1","charset":"utf-8"},{"charset":"utf-8","name":"viewport","content":"width=device-width,initial-scale=1,maximum-scale=2"}],"link":[{"rel":"preconnect","href":"https://js.sentry-cdn.com","crossorigin":"anonymous"},{"rel":"dns-prefetch","href":"https://assets.stringking.com","crossorigin":"anonymous"},{"rel":"preconnect","href":"https://assets.stringking.com","crossorigin":"anonymous"},{"rel":"dns-prefetch","href":"https://cms-static.stringking.com","crossorigin":"anonymous"},{"rel":"dns-prefetch","href":"https://sk-cms.stringking.com","crossorigin":"anonymous"},{"rel":"dns-prefetch","href":"https://images.stringking.com","crossorigin":"anonymous"},{"rel":"preconnect","href":"https://images.stringking.com","crossorigin":"anonymous"},{"rel":"icon","type":"image/x-icon","href":"https://assets.stringking.com/static/sites/stringking/icons/favicon.ico"}],"style":[{"key":"vuetify-layers-ordered","tagPriority":10,"innerHTML":"@layer vuetify-core,vuetify-components,vuetify-overrides,vuetify-utilities,vuetify-final;"}],"script":[{"key":"sentry-init","tagPriority":998,"type":"text/javascript","innerHTML":"!function(n,o){o=n.sentryConfigObj={\"release\":\"bee2e72\",\"initialize\":true,\"debug\":false,\"environment\":\"production\",\"sendDefaultPii\":false,\"tunnel\":\"/api-local/sentry\",\"sampleRate\":0.2,\"ignoreErrors\":[\"window._META\"],\"ignoreSpans\":[{\"op\":\"browser.cache\"},{\"op\":\"browser.connect\"},{\"op\":\"browser.DNS\"},{\"op\":\"resource.other\",\"name\":\".woff\"},{\"op\":\"resource.other\",\"name\":\".ttf\"},{\"op\":\"resource.other\",\"name\":\".eot\"},{\"op\":\"resource.link\",\"name\":\".css\"},{\"op\":\"resource.link\",\"name\":\".js\"},{\"op\":\"resource.script\",\"name\":\".js\"},{\"op\":\"resource.other\",\"name\":\".png\"},{\"op\":\"resource.img\",\"name\":\".png\"},{\"op\":\"resource.other\",\"name\":\".svg\"},{\"op\":\"resource.img\",\"name\":\".svg\"},{\"op\":\"resource.other\",\"name\":\".jpg\"},{\"op\":\"resource.img\",\"name\":\".jpg\"},{\"op\":\"resource.other\",\"name\":\".jpeg\"},{\"op\":\"resource.img\",\"name\":\".jpeg\"},{\"op\":\"resource.other\",\"name\":\".gif\"},{\"op\":\"resource.img\",\"name\":\".gif\"},{\"op\":\"resource.other\",\"name\":\".bmp\"},{\"op\":\"resource.img\",\"name\":\".bmp\"},{\"op\":\"resource.other\",\"name\":\".tif\"},{\"op\":\"resource.img\",\"name\":\".tif\"},{\"op\":\"resource.other\",\"name\":\".webp\"},{\"op\":\"resource.img\",\"name\":\".webp\"},{\"op\":\"resource.other\",\"name\":\".avif\"},{\"op\":\"resource.img\",\"name\":\".avif\"},{\"op\":\"resource.other\",\"name\":\".heic\"},{\"op\":\"resource.img\",\"name\":\".heic\"},{\"op\":\"resource.other\",\"name\":\".heif\"},{\"op\":\"resource.img\",\"name\":\".heif\"},{\"op\":\"resource.other\",\"name\":\".ico\"},{\"op\":\"resource.img\",\"name\":\".ico\"},{\"op\":\"measure\"}],\"tracing\":{\"tracesSampleRate\":0.2,\"vueOptions\":{\"tracing\":true,\"tracingOptions\":{\"hooks\":[\"mount\",\"update\"],\"timeout\":2000,\"trackComponents\":true}}}},n.sentryOnLoad=function(){n.console.log(\"Sentry LOADED!\"),Sentry.init(o)}}(window);","tagPosition":"bodyClose","crossorigin":"anonymous"},{"key":"sentry-loader","tagPriority":999,"src":"https://js.sentry-cdn.com/e09b14886f4f4820a271b7693018003f.min.js","crossorigin":"anonymous","tagPosition":"bodyClose"}],"noscript":[],"htmlAttrs":{"lang":"en"}}

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = {"enabled":false}

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = true

export const componentIslandsActive = true

export const payloadExtraction = false

export const prefetchPreloadTags = false

export const cookieStore = true

export const appManifest = true

export const serverPathFallback = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const useStateDefaults = {"resetOnClear":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const stripNeverHydratedData = false

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false

export const routeTypedFetch = false

export const asyncCallHook = true

export const clientNodePlaceholder = false

export const tracingChannelNuxt = false

export const runtimeCompiler = false

export const vapor = false

export const rawVaporSlotKey = undefined

export const hasPluginDependencies = false

export const hasParallelPlugins = true

export const hasPluginHooks = true

export const hasIslandOptOutPlugins = true